export default __webpack_public_path__ + "static/media/sabaynews-reactjs.e96a408e.JPG";